// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iNoou1LXSZxRJ7icDukb{clear:both;display:flex;align-items:center}.dRa3RUesf7D0I0AFIvOo{flex:1}", "",{"version":3,"sources":["webpack://./src/lib/tools/jsdebugger/watchers.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,YAAA,CACA,kBAAA,CAGF,sBACE,MAAA","sourcesContent":[".watchInputSection {\n  clear: both;\n  display: flex;\n  align-items: center;\n}\n\n.watchTextField {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watchInputSection": "iNoou1LXSZxRJ7icDukb",
	"watchTextField": "dRa3RUesf7D0I0AFIvOo"
};
export default ___CSS_LOADER_EXPORT___;
